module.exports = __webpack_public_path__ + "img/halim-cars.62ec05c5.png";